import type { DatapointOptions, CustomData, InternalDatapointOptions } from 'owa-analytics-types';
import type { AnalyticsCoreEventNames } from 'owa-analytics-events';
import { lazyLogUsage } from '../lazyFunctions';
import { addStackTraceToEvent } from 'owa-analytics-utils/lib/addStackTraceToEvent';
import type { MailboxInfo } from 'owa-client-types';

export function logCoreUsage(
    eventName: AnalyticsCoreEventNames,
    mailbox: MailboxInfo | undefined,
    customData?: CustomData,
    options?: DatapointOptions
): Promise<void> {
    const logCoreUsageOptions: InternalDatapointOptions = {
        ...(options ? options : {}),
        ...(mailbox ? { mailbox } : {}),
    };
    logCoreUsageOptions.isCore = true;
    // Add original stack trace
    addStackTraceToEvent(logCoreUsageOptions);

    return lazyLogUsage.importAndExecute(eventName, mailbox, customData, logCoreUsageOptions);
}
